import { useCallback, useEffect, useState } from 'react'
import createProvider from '@store/provider'
import { connect } from 'react-redux'
import {
  getTrackComments, deleteComment, denormalizeResponse
} from '@common/http'
import CommunityComments from '../community-comments'

function CommunityTrackComments (props) {
  const { currentUser, isAdminUser, mixdownOwnerId, mixdownId } = props

  const isTrackOwner = currentUser?.id === mixdownOwnerId

  const [comments, setComments] = useState([])
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    const handleCommentPosted = () => {
      setComments([])
      setRefreshKey((k) => k + 1)
    }
    window.addEventListener('comment:posted', handleCommentPosted)
    return () => window.removeEventListener('comment:posted', handleCommentPosted)
  }, [])

  const fetchPage = useCallback(async (page) => {
    const { data } = await getTrackComments(mixdownId, { page, items: 10 })
    const denormalizedComments = denormalizeResponse(data)
    setComments([...comments, ...denormalizedComments])
    return { nextPage: data.meta?.next_page }
  }, [comments])

  const handleDeleteComment = (commentId) => {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      deleteComment(commentId)
    }
  }

  return (
    <CommunityComments
      key={refreshKey}
      comments={comments}
      onDeleteComment={handleDeleteComment}
      fetchPage={fetchPage}
      isAdmin={isAdminUser || isTrackOwner}
    />
  )
}

const mapStateToProps = (state) => {
  const { currentUser } = state.backendData

  return {
    currentUser
  }
}

export default createProvider(
  connect(mapStateToProps)(CommunityTrackComments)
)
